import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import DollarSignIcon from '@wix/da-ds/pkg/Icons/16x16/DollarSign';
import DollarPriceInput from '@wix/da-shared-react/pkg/DollarPriceInput';
import { QuestionFieldName } from '../../types';

import s from './AnswerChoiceField.scss';

interface Props {
  index: number;
  field: any;
  inputPrefix?: React.ReactNode;
}

const AnswerChoiceField: React.FC<Props> = ({ index, field, inputPrefix }) => {
  const { t } = useTranslation();
  const { register, errors } = useFormContext();
  const [withPrice, setWithPrice] = useState(!!field.price);
  const error = errors[QuestionFieldName.ANSWER_CHOICES]?.[index]?.answerText;
  return (
    <div className={s['root']}>
      <TextInput
        wrapperClassName={s['input-wrapper']}
        id={`answer-text-${index}`}
        label={t('customExclusivePopup.questionnaire.form.answer.label', {
          index: index + 1,
        })}
        ref={register()}
        name={`${QuestionFieldName.ANSWER_CHOICES}[${index}].answerText`}
        defaultValue={field.answerText}
        prefix={inputPrefix}
        placeholder={t('customExclusivePopup.questionnaire.form.answer.label', {
          index: index + 1,
        })}
        validationResult={error ? 'error' : undefined}
        details={error && error.message}
        isLabelHidden
        noBottomSpacing
      />
      {withPrice && (
        <div className={s['price']}>
          <DollarPriceInput
            label={t('customExclusivePopup.questionnaire.form.price.label')}
            name={`${QuestionFieldName.ANSWER_CHOICES}[${index}].price`}
            ref={register()}
            defaultValue={field.price}
            isLabelHidden
            noBottomSpacing
          />
        </div>
      )}
      {!withPrice && (
        <IconButtonWithBackground
          className={s['price-button']}
          size="small"
          icon={DollarSignIcon}
          aria-label={t('customExclusivePopup.questionnaire.form.setPrice')}
          onClick={() => setWithPrice(true)}
        />
      )}
    </div>
  );
};
AnswerChoiceField.displayName = 'AnswerChoiceField';

export default AnswerChoiceField;
